module.exports = __webpack_public_path__ + "img/callendar+entrance.6011b736.png";